module.exports = __webpack_public_path__ + "img/portrait.412876e4.jpg";